import React, { Component } from 'react'
import styled from 'styled-components'
import base64 from 'base-64';
import utf8 from 'utf8';
import syncGetQRCode from '../../../common/QRCode'
import { GREEN50, WHITE, BLACK, YELLOW254 } from '../../../common/constants.js'

const clientWidth = window.screen.width;
const clientHeight = window.screen.height;

class ControlSuger extends Component {

  constructor(props){
    super(props);
    this.state = {
        qrcodeUrl: null
    }       
}
componentWillMount = () =>{

    const setState = this.setState.bind(this); 
    const bytes = base64.decode(this.props.match.params.data);
    const text = utf8.decode(bytes);
    const data=JSON.parse(text)
    const postData={
      "userId": data.userId,
      "title": data.name,
      "description": "个人邀请二维码",
      "marketingChannel": "WECHAT_REFERRAL",
      "location": "微信公众号",
      "action": "INVITE_PATIENT"
     }
    syncGetQRCode(postData).then(function(url){
      setState({qrcodeUrl: url});
    })

  }

  render() {
    console.log('clientWidth', clientWidth, 'clientHeight', clientHeight)
    const bytes = base64.decode(this.props.match.params.data);
    const text = utf8.decode(bytes);
    const data=JSON.parse(text);
    const type=data.type;
    let imgPath='';
    if(type==='SUPERIOR_SOLDIER'){
      imgPath='super_soldier.gif'
    }else{
      imgPath='speed_squad.gif'
    }
    return(
      <Container>
      <Rewart>
       
        <TopContainer>
          <TopTitle>
          {(()=>{
            if(type==='SUPERIOR_SOLDIER'){
              return(
                <div>
                  <UpText >{data.name}在{data.healthCareTeam}共同照护门诊</UpText>
                  <UpText >管理下糖化值小于7%</UpText>
                  </div>
              )
              
            }else{
              return(
                <div>
                  <UpText >{data.name}在{data.healthCareTeam}共同照护门诊</UpText>
                  <UpText >3个月糖化值下降了{data.falling}%</UpText>
                  </div>
              )
            }
          })()}
          </TopTitle>
            <img src={require(`./images/${imgPath}`)} width='100%'  />
            <ButtomText >
            <TitleView>
              <ContentText>您想有效稳定的控制好血糖吗</ContentText>
            </TitleView>
            <TitleView>
              <ContentText>您想众多医疗专家为您集体会诊吗</ContentText>
            </TitleView>
            <TitleView>
              <ContentText>您想随时随地获得糖尿病管理服务吗</ContentText>
            </TitleView>
          </ButtomText>
        </TopContainer>
      </Rewart>
      
      <Promotion>
      <TipTextView>
            <TipText>咨询电话</TipText>
            <TipText>400-000-6813</TipText>
          </TipTextView>
          <TipTextView>
            <QrcodeImage src={this.state.qrcodeUrl} />
            <TipText>长按识别二维码</TipText>
            <TipText>预约初诊</TipText>
          </TipTextView>
      </Promotion>

    </Container>
    )
  }

}
export default ControlSuger

const Container= styled.div`
  display:flex;
  height:100vh;
  flex-direction:column;
  background-color: ${WHITE};
`

const Rewart= styled.div`
  flex:1;
`

const Promotion= styled.div`
  flex:1;
  background-color: ${WHITE};
`

const TopTitle=styled.div`
position: absolute;
top: 20px;
text-align: center;
width: 100%;
`

const ButtomText=styled.div`
  position: absolute;
  bottom:30px;
  width: 100%;
  text-align:center;
`
const TopContainer=styled.div`
  position: relative;
`


const UpText = styled.div`
  font-size: 20px;
  margin-top:5px;
  margin-left:auto;
  margin-right:auto;
  font-weight: bold;
  color: ${BLACK};
  text-align: center;
  `

const TitleView = styled.div`
     flex-direction: row;
     justify-content: flex-start;
     align-items: center;
   `
const ContentText = styled.div`
     font-size: 17px;
     font-weight: bold;
     padding-top: 15px;
     
     color: ${BLACK};
   `

const TipTextView = styled.div`
     margin-top:20px;
     margin-left:25px;
     margin-right:25px;
     text-align:center;
   `
const TipText = styled.div`
     font-size: 16px;
     font-weight: bold;
     color: ${BLACK};
     margin-top:5px;
   `
const QrcodeImage = styled.img`
     width: 100px;
     height: 100px;
     margin-bottom:10px;
 ` 



// WEBPACK FOOTER //
// ./src/modules/wechatShare/components/controlSuger.js